import { render, staticRenderFns } from "./CreateReservation.vue?vue&type=template&id=74c21052"
import script from "./CreateReservation.vue?vue&type=script&lang=js"
export * from "./CreateReservation.vue?vue&type=script&lang=js"
import style0 from "./CreateReservation.vue?vue&type=style&index=0&id=74c21052&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports